module.exports = __webpack_public_path__ + "img/horizontal_6_2_5010.e95671a7.png";